import React, { useState } from "react";
import { FeatureFlagEnabled, Loader, PolyInternalBadge } from "elements";
import { useTranslation } from "utilities/i18n";
import {
  columnTranslations,
  NetworkInfoTranslateKeys
} from "./NetworkInfoHelpers";
import { filterDeviceInfoOnString } from "./DeviceInformation";
import { useNetworkLinesQuery } from "../../../../../generated/graphql";
import { ExpandableCard } from "../../../../../collections/Cards";

interface NISectionProps {
  searchState: string;
  deviceId: string;
}
const context = {
  maskTypename: true
};
export const NetworkInfo: React.FC<NISectionProps> = ({
  searchState,
  deviceId
}) => {
  const { data, fetching, stale } = useNetworkLinesQuery({
    variables: {
      deviceId
    },
    context
  });
  const { t } = useTranslation();
  const networkInfo =
    data?.capabilitiesQuery?.com?.poly?.network_information?.interfaces
      ?.value ?? [];
  const exists = !fetching && !stale && networkInfo.length > 0;
  const [showNullItems, setShowNullItems] = useState(false);

  function mapNetworkInfoItem(key: any, value: any) {
    const keyName = key as keyof NetworkInfoTranslateKeys;
    return (
      <div className="ni-field-grouping" key={`${key}-${value}`}>
        <label className="ni-field-label">{`${columnTranslations[keyName]}:`}</label>
        <p className="ni-field-value">{value} </p>
      </div>
    );
  }

  return (
    <ExpandableCard
      collapsedContent={
        <div className={`category-title pl-5 ${exists ? "" : "mid-gray"}`}>
          {t("NETWORK_INFORMATION")}
        </div>
      }
      dropdown
      expanded={false}
      disabled={!exists}
    >
      <div className="network-info" data-testid="network-info">
        <Loader loading={fetching}>
          {networkInfo.map((niMessage, i) => {
            const header =
              niMessage.interfacename ??
              t("NETWORK_INFO_TITLE", { number: i + 1 });
            return (
              <section key={`network-info-${i + 1}`} className="ni-data">
                <h3 className="network-header mb-1">{header}</h3>
                {filterDeviceInfoOnString(searchState, niMessage, "ni")
                  .filter(
                    ([key, value]) => value !== null && key !== "__typename"
                  )
                  .map(([key, value]) => mapNetworkInfoItem(key, value))}
                <FeatureFlagEnabled feature="IS_POLY_USER">
                  <div
                    className="show-null"
                    onClick={() => setShowNullItems(!showNullItems)}
                    data-testid="toggle-ni-null-items"
                  >
                    {showNullItems
                      ? t("HIDE_NULL_INFORMATION")
                      : t("SHOW_NULL_INFORMATION")}
                  </div>
                  {<PolyInternalBadge />}
                  {showNullItems && (
                    <div data-testid="ni-null-items">
                      {filterDeviceInfoOnString(searchState, niMessage, "ni")
                        .filter(
                          ([key, value]) =>
                            value === null && key !== "__typename"
                        )
                        .map(([key, value]) => mapNetworkInfoItem(key, value))}
                    </div>
                  )}
                </FeatureFlagEnabled>
              </section>
            );
          })}
        </Loader>
      </div>
    </ExpandableCard>
  );
};
